'use client';

import { useContentfulLiveUpdates } from '@contentful/live-preview/react';
import Header from '@/components/Header';
import { Markdown } from '@/lib/markdown';
import ITermsAndPrivacy from '@/models/termsAndPrivacy';

export default function TermsAndConditionsPage(props: {
	termsAndConditionsPage: ITermsAndPrivacy;
	preview?: boolean;
}) {
	'use client';

	const termsAndConditionsPage = props.termsAndConditionsPage;

	if (!termsAndConditionsPage) {
		return null;
	}

	return (
		<section className="-mt-16">
			<div className="z-20 relative bg-contain xl:bg-cover bg-white text-white bg-bottom  flex flex-col">
				<Header
					small
					title={termsAndConditionsPage?.termsAndConditionsTitle}
					headerSliderImagesCollection={{
						items: [termsAndConditionsPage?.termsAndConditionsSeoImage],
					}}
				/>
			</div>

			<div className="z-20 relative black py-12 md:py-32 flex flex-col container max-w-5xl [&_a]:text-primary-500 [&_a]:font-bold [&_a:hover]:underline">
				<Markdown content={termsAndConditionsPage?.termsAndConditionsContent} />
			</div>
		</section>
	);
}
